import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { getParameterByName } from "../../util/commonFunctions";
import { LoaderComponent } from "../../components/loader";
import {
  setToken,
  setUser,
  hideLoader,
  showLoader,
  logout
} from "../../actions";

class MobileProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.props.onLogout();
    this.props.showLoader();
  }

  componentDidMount() {
    const verifyToken = decodeURIComponent(window.location.search);
    const token =
      getParameterByName("token", verifyToken) &&
      getParameterByName("token", verifyToken).length > 0 &&
      getParameterByName("token", verifyToken);
    if (token) {
      this.props.setToken(token);
      this.props.setUser(token);
    }
  }

  render() {
    return this.props.token &&
      this.props.userProfile &&
      this.props.hideLoader() ? (
      <Redirect to="/profile/personal" />
    ) : (
      <React.Fragment>
        <Helmet title="MobileProfile" />
        <LoaderComponent isLoading={this.state.loader} />

        <div className="container">
          <div className="row">
            <div className="col-12 no-gutter-col">
              <p className="error"></p>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    token: state.auth.token,
    loader: state.loader.loader,
    userProfile: state.auth.userProfile
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setToken: (token, provider) => dispatch(setToken(token, provider)),
    setUser: token => dispatch(setUser(token)),
    showLoader: () => dispatch(showLoader()),
    hideLoader: () => dispatch(hideLoader()),
    onLogout: () => dispatch(logout())
  };
};

export default {
  component: connect(mapStateToProps, mapDispatchToProps)(MobileProfile)
};
